import { useEffect } from 'react';
import { getIsRecipient } from 'config/permissions';
import { useAppSelector } from 'helpers/hooks';
import { consumePendingLogin, mixpanelClient } from 'helpers/mixpanel';
import { AdminContextProperties, trackEvent } from 'helpers/mixpanelEvents';
import { getActiveRole, getSelectedRecipientId } from 'selectors/admins';
import { getUserClientId } from 'selectors/user';

/**
 * Keeps the admin's role, client and recipient attached to every Mixpanel event, and fires
 * `Admin Logged In` once those are known after a real sign-in.
 */
export const useMixpanelAdminContext = () => {
  const activeRole = useAppSelector(getActiveRole);
  const clientId = useAppSelector(getUserClientId);
  const recipientId = useAppSelector(getSelectedRecipientId);

  useEffect(() => {
    if (!activeRole) return;

    const isRecipient = getIsRecipient(activeRole);
    const adminContext: AdminContextProperties = {
      admin_type: activeRole,
      client_id: isRecipient ? null : clientId,
      recipient_id: isRecipient && recipientId ? recipientId : null,
    };
    mixpanelClient.register(adminContext);

    if (consumePendingLogin()) {
      trackEvent('Admin Logged In', {});
    }
  }, [activeRole, clientId, recipientId]);
};
